// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store/index'
import '@/plugins/vux.js'
import '@/global.js'
import '@/styles/common.scss'
import { beforeInit } from '@/utils/app'

const appInit = () => {
  // eslint-disable-next-line
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
  })
}

beforeInit().then(() => {
  appInit()
})



// WEBPACK FOOTER //
// ./src/main.js